import { iTema } from "../../../usuario/usuario.interface";
export interface ITemasLectura extends Array<string> {}

export const getUserRoles = (roles: { [key: string]: iTema }) => {
  // Filtrar temas de lectura
  const rolesLectura: ITemasLectura = Object.keys(roles).filter((item) => {
    return roles[item].permiso === 1 || roles[item].permiso === 3;
  }) as ITemasLectura;
  console.log("temasLectura", rolesLectura);

  // Filtrar temas de escritura
  const rolesEscritura: ITemasLectura = Object.keys(roles).filter((item) => {
    return roles[item].permiso === 2 || roles[item].permiso === 3;
  }) as ITemasLectura;

  return {
    rolesEscritura,
    rolesLectura,
  };
};
